module.exports = __webpack_public_path__ + "img/cintes-adhesives-packetgrup.ed60e6bc.jpg";